import type { Directive } from 'vue'

// since we get the elements directly as raw html elements, we need
// a custom directive to append them to the DOM in Vue
// this is seend in the template as v-participant-element
const appendImageIf = (el: HTMLElement, parent: HTMLElement) => {
	if (!el.getAttribute('data-type') || el.getAttribute('data-type') !== 'avatar') {
		return
	}
	if (el.querySelector('img')) {
		// already has an image
		return
	}
    const url = parent.getAttribute('data-logo-url')
	const img = document.createElement('img')
	img.setAttribute('src', url || '')
	img.setAttribute('crossorigin', 'anonymous') // allow cross-origin images
	el.appendChild(img)
}
const vParticipantElement: Directive<HTMLElement, HTMLElement | null> = {
	mounted: (el: HTMLElement, binding: { value: HTMLElement | null }) => {
		if (binding && binding.value) {
			el.appendChild(binding.value)
			appendImageIf(binding.value, el)
		}
	},
	updated: (el: HTMLElement, binding: { value: HTMLElement | null }) => {
		// Clear the element first
		console.debug('v-participant-element: updated', el, binding.value)
		if(el.firstChild == binding.value) {
			// already has the same element, no need to update
			return
		}
		el.innerHTML = ''
		if (binding && binding.value) {
			el.appendChild(binding.value)
			appendImageIf(binding.value, el)
		}
	}
}
export default vParticipantElement